import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { Injectable } from '@angular/core';
import { GlobalServiceProvider } from '../global-service/global-service';
import 'rxjs/add/operator/toPromise';
import { Job } from '../../model/job';
import { Observable } from 'rxjs/Observable';

const options = new RequestOptions({
  headers: new Headers({
    'Content-Type': 'application/json'
  })
});

@Injectable()
export class CustomerServiceProvider {

  baseUrl: String = this.globalServiceProvider.appConfig.BaseApiUrl;
  baseUrlTms: String = this.globalServiceProvider.appConfig.BaseApiTmsUrl;
  ixomBasURL: String = this.globalServiceProvider.appConfig.ixomApiUrl;
  fetchUrl = "api/consignments";
  constructor(
    public http: Http,
    public globalServiceProvider: GlobalServiceProvider,

  ) {
    // console.log('Hello CustomerServiceProvider Provider');
  }
  private upcomingJobs: any = null;
  get getUpcomingJobs(): any {
    return this.upcomingJobs;
  }
  set setUpcomingJobs(valueObj: any) {
    this.upcomingJobs = valueObj;
  }
  private currentJobs: any = null;
  get getCurrentJobs(): any {
    return this.currentJobs;
  }
  set setCurrentJobs(valueObj: any) {
    this.currentJobs = valueObj;
  }
  private completeJobs: any = null;
  get getCompleteJobs(): any {
    return this.completeJobs;
  }
  set setCompleteJobs(valueObj: any) {
    this.completeJobs = valueObj;
  }
  private incomingJobs: any = null;
  get getIncomingJobs(): any {
    return this.incomingJobs;
  }
  set setIncomingJobs(valueObj: any) {
    this.incomingJobs = valueObj;
  }
  private consignmentLegList: any = null;
  get getConsignmentLegList(): any {
    return this.consignmentLegList;
  }
  set setConsignmentLegList(valueObj: any) {
    this.consignmentLegList = valueObj;
  }

  getCustomerUpcomingJobsV3(custCode, isSiteAccount): Observable<Job[]> {
    let uri = this.baseUrl + '/api/v3/jobs/upcoming';
    return this.http.post(uri, { data: custCode, isSiteAcc: isSiteAccount }, options)
      .map((res: Response) => res.json().map(item => {
        return new Job(item);
      }))
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }


  getCustomerCurrentJobsV3(custCode, isSiteAccount) {
    let uri = this.baseUrl + '/api/v3/jobs/current';
    return this.http.post(uri, { data: custCode, isSiteAcc: isSiteAccount }, options)
      .map((res: Response) => res.json().map(item => {
        return new Job(item);
      }))
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  getCustomerCompleteJobsV3(custCode,isSiteAccount) {
    let uri = this.baseUrl + '/api/v3/jobs/complete';
    return this.http.post(uri, { data: custCode, isSiteAcc: isSiteAccount }, options)
      .map((res: Response) => res.json().map(item => {
        return new Job(item);
      }))
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }
  getCustomerJobs(custCode) {
    let uri = this.baseUrl + '/api/jobs/customer/' + custCode;
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }
  getJobLinesById(id) {
    let uri = this.baseUrl + '/api/v2/jobs/tankerproduct/' + id;
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }


  getConsignments(custCode, pageNo) {
    let uri = this.baseUrl + '/api/consignment/' + custCode + '/' + pageNo;
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }
  searchConsignments(searchString, custCode, pageNo) {
    let uri = this.baseUrl + '/api/consignment/search/' + searchString + '/' + custCode + '/' + pageNo;
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  extractData(res: Response) {
    let body = res.json();
    return body || {};
  }
  handleErrorObservable(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.message || error);
  }
  getLegs(jobId) {
    let uri = this.baseUrl + '/api/jobs/legs/' + jobId;
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }
  getTankerLocation(tankers) {

    // let uri = this.baseUrl + '/api/mtdata/tankerposition';
    let uri = this.baseUrl + '/api/data/tankerpositionv5';
    let result = null;
    return this.http
      .post(uri, { tankers: tankers })
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(err => {
        console.log('err:', err);
        return null;
      })
  }

  getPrimoveAndTankerLocation(tankers) {
    let uri = this.baseUrl + '/api/data/tankerpositionv6';
    let result = null;
    return this.http
      .post(uri, { tankers: tankers })
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(err => {
        console.log('err:', err);
        return null;
      })
  }

  getJobScheduleHistory(id) {
    let uri = this.baseUrl + '/api/v3/jobs/jobschedulehistory/' + id;
    console.log('uri', uri);
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  getTemperature(id, data) {
    let uri = this.baseUrl + '/api/v3/orbcomm/get/' + id;
    console.log('uri', uri);
    let result = null;
    return this.http
      .put(uri, data)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  getOrbcomm() {
    let uri = this.baseUrl + '/api/orbcomm/data';
    console.log('uri', uri);
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  getIxomJobDocument(jobID: number, type: string) {
    return new Promise<any[]>((resolve: any, reject: any) => {
      let uri = `${this.baseUrl}/api/ixom/jobdocuments?jobId=${jobID}&type=${type}`;
      let result = null;
      return this.http
        .get(uri)
        .toPromise()
        .then(data => {
          result = data.json();
          resolve(result);
        })
        .catch(          
          err => {
            resolve([]);
          }
        )
    });
  }

  getIxomJLegsDatetime(jobID: number) {
    return new Promise<any[]>((resolve: any, reject: any) => {
      let uri = `${this.baseUrl}/api/ixom/legs/datetime?jobId=${jobID}`;
      let result = null;
      return this.http
        .get(uri)
        .toPromise()
        .then(data => {
          result = data.json();
          resolve(result);
        })
        .catch(          
          err => {
            resolve([]);
          }
        )
    });
  }

  async getIxomByJob(jobNo: number) {
    return new Promise<any[]>((resolve: any, reject: any) => {      
      let uri = `${this.ixomBasURL}/ixom/api/v2/ixomsbyjob?fk_Job=${jobNo}`;
      let result = null;
      return this.http
        .get(uri)
        .toPromise()
        .then(data => {
          result = data.json();
          resolve(result);
        })
        .catch(          
          err => {
            resolve([]);
          }
        )
    });
  }

  getIxomUpcoming(date: string, custCode: string, isSiteAcc: boolean) {
    return new Promise<Array<Job>>((resolve: any, reject: any) => {      
      let uri = `${this.ixomBasURL}/ixom/api/v1/upcoming`;
      let result = null;
      return this.http
        .get(uri, { params: { date: date, custCode: custCode, isSiteAcc: isSiteAcc } })
        .toPromise()
        .then(data => {
          result = data.json().map(item => {
            return new Job(item);
          });
          resolve(result);
        })
        .catch(          
          err => {
            resolve([]);
          }
        )
    });
  }

  getIxomCurrent(date: string, custCode: string, isSiteAcc: boolean) {
    return new Promise<Array<Job>>((resolve: any, reject: any) => {      
      let uri = `${this.ixomBasURL}/ixom/api/v1/current`;
      let result = null;
      return this.http
        .get(uri, { params: { date: date, custCode: custCode, isSiteAcc: isSiteAcc } })
        .toPromise()
        .then(data => {
          result = data.json().map(item => {
            return new Job(item);
          });
          resolve(result);
        })
        .catch(          
          err => {
            resolve([]);
          }
        )
    });
  }

  getIxomCompleted(date: string, custCode: string, isSiteAcc: boolean) {
    return new Promise<Array<Job>>((resolve: any, reject: any) => {      
      let uri = `${this.ixomBasURL}/ixom/api/v1/complete`;
      let result = null;
      return this.http
        .get(uri, { params: { date: date, custCode: custCode, isSiteAcc: isSiteAcc } })
        .toPromise()
        .then(data => {
          result = data.json().map(item => {
            return new Job(item);
          });
          resolve(result);
        })
        .catch(          
          err => {
            resolve([]);
          }
        )
    });
  }

  getTankerLocationV7(tankers, vehicleID) {
    let uri = this.baseUrl + '/api/data/tankerpositionv7';
    let result = null;
    return this.http
      .post(uri, { tankers: tankers, vehicleID: vehicleID})
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(err => {
        console.log('err:', err);
        return null;
      })
  }
}




// WEBPACK FOOTER //
// ./src/providers/customer-service/customer-service.ts